export const initialQuickLookSettings = {}
